import location from "../assets/ic-step1-location.svg"
import terraform from "../assets/ic-step2-terraform.svg"
import vizNow from "../assets/ic-step3-viznow.svg"
import deploy from "../assets/ic-step4-deploy.svg"

export default { location, terraform, vizNow, deploy }
